import { css } from 'styled-components';
import { breakpoints } from './breakpoints';

export const media = {
  xxlDown: (styles) => css`
    @media (max-width: ${breakpoints.xxl}px) {
      ${styles}!important;
    }
  `,
  xlDown: (styles) => css`
    @media (max-width: ${breakpoints.xl}px) {
      ${styles} !important;
    }
  `,
  lgDown: (styles) => css`
    @media (max-width: ${breakpoints.lg}px) {
      ${styles}
    }
  `,
  mdDown: (styles) => css`
    @media (max-width: ${breakpoints.md}px) {
      ${styles}
    }
  `,
  smDown: (styles) => css`
    @media (max-width: ${breakpoints.sm}px) {
      ${styles}
    }
  `,
};
